import { DynamicContentType } from '../../types/content.types.js'
import { LucideIconName } from '../../types/lucide.types.js'

export type ContactFormData = {
  responseEmail: string
  header: string
  instruction: string
  marginBottom: string
}

export const contactform: DynamicContentType<ContactFormData> = {
  name: 'contactform',
  viewName: 'Kontaktformulär',
  featureKey: 'contactform',
  icon: LucideIconName.Phone,
  uuid: '',
  default: true,
  data: {
    responseEmail: '',
    header: 'Kontakta oss',
    instruction: '',
    marginBottom: '1rem',
  },
}
